import Container, { Service, Token } from 'typedi';
import { Lock } from '../../utils/lockUtil';
import { BaseModuleLoader } from '../../../loaders/BaseModuleLoader';
import { ClientSettings } from './client-settings';
import { ClientProvider } from '../../../models/enums/general-enums';
import { Utils } from '../../utils';

const moduleLock = new Lock();

export const ClientSettingsToken = new Token<ClientSettings>('ClientSettings');

@Service()
export class ClientSettingsLoader extends BaseModuleLoader<ClientSettings> {
    constructor() {
        super('ClientSettingsLoader');
    }

    protected _createModuleInstance = async (): Promise<ClientSettings> => {
        const clientProvider = Container.get(Utils).getClientProvider();

        switch (clientProvider) {
            case ClientProvider.Kambi: {
                const module = await import(
                    /* webpackChunkName: "client-settings/kambi" */
                    './kambi-client-settings'
                );
                return new module.KambiClientSettings();
            }
            case ClientProvider.Poker: {
                const module = await import(
                    /* webpackChunkName: "client-settings/poker" */
                    './poker-client-settings'
                );
                return new module.PokerClientSettings();
            }
            case ClientProvider.Spectate:
            default: {
                const module = await import(
                    /* webpackChunkName: "client-settings/spectate" */
                    './spectate-client-settings'
                );
                return new module.SpectateClientSettings();
            }
        }
    };

    protected override _canUse: () => Promise<boolean> = async () => true;

    protected override _getModuleLock = (): Lock => moduleLock;
    protected override _getToken = (): Token<ClientSettings> => ClientSettingsToken;
}
